import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Insurance } from '../_models/insurance.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class InsurancesService {
  private authToken;
  private companyId: any;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  private static getInsurancesListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.id) fromString += `&id_has=${filter.id}`;
      if (filter.insuranceType) fromString += `&insurance_type_has=${filter.insuranceType}`;
      if (filter.submissionType) fromString += `&submission_type_has=${filter.submissionType}`;
      if (filter.bin) fromString += `&bin_has=${filter.bin}`;
      if (filter.phone) fromString += `&phone_has=${filter.phone}`;
      if (filter.pcn) fromString += `&pcn_has=${filter.pcn}`;
    }

    return fromString;
  }
  createInsurance(_insurance: Insurance) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set('Content-Type', 'application/json');
    httpHeaders = httpHeaders.set('Authorization', 'Bearer ' + this.authToken);
    const body = {
      bin: _insurance.bin,
      pcn: _insurance.pcn,
      phone: _insurance.phone,
      name: _insurance.name,
      insurance_type: _insurance.insuranceType,
      submission_type: _insurance.submissionType,
    };
    return this.http.post<Insurance>(
      environment.CORE_BASE + '/companies/' + this.companyId + '/insurance',
      body,
      {
        headers: httpHeaders,
        observe: 'response',
      },
    );
  }

  getInsuranceById(insuranceId: number): Observable<Insurance> {
    const body = {
      id: insuranceId,
    };
    const url = environment.CORE_BASE + '/insurances';
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Insurance>(url, body, { headers: httpHeaders });
  }

  findInsurances(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: InsurancesService.getInsurancesListQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(
      `${environment.CORE_BASE}/companies/${this.companyId}/insurance`,
      { params },
    );
  }

  updateInsurance(_insurance: Insurance): Observable<any> {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set('Content-Type', 'application/json');
    httpHeaders = httpHeaders.set('Authorization', 'Bearer ' + this.authToken);
    const body = {
      bin: _insurance.bin,
      pcn: _insurance.pcn,
      phone: _insurance.phone,
      name: _insurance.name,
      insurance_type: _insurance.insuranceType,
      submission_type: _insurance.submissionType,
    };
    const id = _insurance.id;
    return this.http.put(
      environment.CORE_BASE + '/companies/' + this.companyId + '/insurance/' + id,
      body,
      { headers: httpHeaders },
    );
  }

  deleteInsurance(insuranceId: number): Observable<any> {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set('Content-Type', 'application/json');
    httpHeaders = httpHeaders.set('Authorization', 'Bearer ' + this.authToken);
    return this.http.delete<any>(
      environment.CORE_BASE + '/companies/' + this.companyId + '/insurance/' + insuranceId,
      { headers: httpHeaders },
    );
  }

  insuranceAutocomplete(term: string): Observable<any> {
    const url =
      environment.CORE_BASE +
      '/companies/' +
      this.companyId +
      '/insurance/autocomplete?sort=name,asc&term=' +
      term;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers: httpHeaders });
  }
}
